import { render, staticRenderFns } from "./monitoringList.vue?vue&type=template&id=56fa212d&scoped=true"
import script from "./monitoringList.vue?vue&type=script&lang=js"
export * from "./monitoringList.vue?vue&type=script&lang=js"
import style0 from "./monitoringList.vue?vue&type=style&index=0&id=56fa212d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa212d",
  null
  
)

export default component.exports